import { Button, type ButtonProps, Text, Tooltip } from "@chakra-ui/react";
import { BooleanState } from "@src/utils/mobx/states/BooleanState";
import { makeObservable } from "mobx";
import { observer, useLocalObservable } from "mobx-react-lite";
import { createRef, useEffect } from "react";

type FilterOptionButtonProps = Omit<ButtonProps, "children"> & {
  readonly label: string;
};

export const FilterOptionButton = observer(function FilterOptionButton({
  label,
  onMouseEnter,
  onMouseLeave,
  ...props
}: FilterOptionButtonProps) {
  const store = useLocalObservable(() => new FilterOptionButtonStore());

  useEffect(() => {
    if (!store.labelRef.current) return;

    store.labelRef.current.scrollWidth > store.labelRef.current.clientWidth
      ? store.isTooltipDisabled.off()
      : store.isTooltipDisabled.on();
  }, [store.labelRef]);

  return (
    <Tooltip
      hasArrow
      isDisabled={store.isTooltipDisabled.value}
      label={label}
      placement="top-start"
    >
      <Button {...props}>
        <Text
          ref={store.labelRef}
          overflow="hidden"
          w="full"
          whiteSpace="nowrap"
          textOverflow="ellipsis"
          textAlign="left"
          color="black"
        >
          {label}
        </Text>
      </Button>
    </Tooltip>
  );
});

class FilterOptionButtonStore {
  isTooltipDisabled = new BooleanState(true);

  labelRef = createRef<HTMLDivElement>();

  constructor() {
    makeObservable(this);
  }
}
